<template>
    <div class="login-container">
        <!-- <div class="login-title">
      <p>知识图谱</p>
    </div> -->
        <div class="ls">
            <h2 class="title">YX-WRQ 知识图谱</h2>
            <div class="title-container">
                <h3 class="title">用户登录</h3>
            </div>
            <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" autocomplete="on"
                label-position="left">
                <el-form-item prop="username">
                    <span class="svg-container">
                        <svg-icon icon-class="user" />
                    </span>
                    <el-input ref="username" v-model="loginForm.username" placeholder="用户名" name="username" type="text"
                        tabindex="1" autocomplete="on" />
                </el-form-item>

                <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
                    <el-form-item prop="password">
                        <span class="svg-container">
                            <svg-icon icon-class="password" />
                        </span>
                        <el-input :key="passwordType" ref="password" v-model="loginForm.password" :type="passwordType"
                            placeholder="密码" name="password" tabindex="2" autocomplete="on" @keyup.native="checkCapslock"
                            @blur="capsTooltip = false" @keyup.enter.native="handleLogin">
                            <i slot="suffix" @click="showPwd" style="margin-right: 10px" class="el-icon-view"></i>
                        </el-input>
                        <!-- <span class="show-pwd" @click="showPwd">
              <svg-icon
                :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'"
              />
            </span> -->
                    </el-form-item>
                </el-tooltip>
                <el-form-item>
                    <el-button :loading="loading" type="primary" style="width: 100%; margin-bottom: 30px"
                        @click.native.prevent="handleLogin">登录</el-button>
                    <div style="display: flex;justify-content: space-around;">
                        <el-link type="success" @click.native.prevent="resetLogin" style="font-size: 16px;">重置密码</el-link>
                        <el-link type="primary" @click.native.prevent="gotoSign" style="font-size: 16px;">注册</el-link>
                    </div>
                    <!-- <el-button  type="primary" style="width: 30%; margin-bottom: 30px"
                        @click.native.prevent="resetLogin" link>重置密码</el-button> -->
                    <!-- <el-button type="primary" style="width: 30%; margin-bottom: 30px" @click.native.prevent="gotoSign"
                        link>注册</el-button> -->
                </el-form-item>
            </el-form>
        </div>
        <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <el-form :model="user" ref="refRuleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="姓名" prop="roleName">
                    <el-input v-model="user.c_name"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="roleName">
                    <el-input v-model="user.c_mobile"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="dialogVisibleConfirm">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import userApi from "@/api/user";
import md5 from "js-md5";
// import SocialSign from './components/SocialSignin'
// import { getPowerRouter, getuserGroupNew } from '@/api/gc'
// import { getUserByMobile } from '@/api/user'
// import Cookies from 'js-cookie'

// const TokenKey = 'Admin-Token'
export default {
    name: "Login",
    //   components: { SocialSign },
    data() {
        // const validateUsername = (rule, value, callback) => {
        //   if (!validUsername(value)) {
        //     callback(new Error('Please enter the correct user name'))
        //   } else {
        //     callback()
        //   }
        // }
        // const validatePassword = (rule, value, callback) => {
        //   if (value.length < 6) {
        //     callback(new Error('The password can not be less than 6 digits'))
        //   } else {
        //     callback()
        //   }
        // }
        return {
            title: "重置密码",
            loginForm: {
                username: "",
                password: "",
            },
            user: {
                c_name: "",
                c_mobile: "",
            },
            dialogVisible: false,
            loginRules: {
                username: [
                    { required: true, message: "请输入用户名", trigger: "blur" },
                ],
                password: [{ required: true, message: "请输入密码", trigger: "blur" }],
            },
            passwordType: "password",
            capsTooltip: false,
            loading: false,
            showDialog: false,
            redirect: undefined,
            otherQuery: {},
        };
    },
    watch: {
        $route: {
            handler: function (route) {
                const query = route.query;
                if (query) {
                    this.redirect = query.redirect;
                    this.otherQuery = this.getOtherQuery(query);
                }
            },
            immediate: true,
        },
    },
    created() {
        // window.addEventListener('storage', this.afterQRScan)
    },
    mounted() {
        if (this.loginForm.username === "") {
            this.$refs.username.focus();
        } else if (this.loginForm.password === "") {
            this.$refs.password.focus();
        }
    },
    destroyed() {
        // window.removeEventListener('storage', this.afterQRScan)
    },
    methods: {
        checkCapslock(e) {
            const { key } = e;
            this.capsTooltip = key && key.length === 1 && key >= "A" && key <= "Z";
        },
        showPwd() {
            if (this.passwordType === "password") {
                this.passwordType = "";
            } else {
                this.passwordType = "password";
            }
            this.$nextTick(() => {
                this.$refs.password.focus();
            });
        },
        handleLogin() {
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    userApi
                        .login({
                            username: this.loginForm.username,
                            password: md5(this.loginForm.password),
                        })
                        .then((res) => {
                            if (res.data.code == 200) {
                                sessionStorage.setItem("token", res.data.data);
                                this.$message({
                                    message: "登录成功",
                                    type: "success",
                                    duration: 1000,
                                });
                                this.$router.push({ path: "/" });
                            } else {
                                this.$message.error(res.data.msg);
                            }
                            // 获取路由
                            this.loading = false;
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                } else {
                    //console.log("error submit!!");
                    return false;
                }
            });
        },

        resetLogin() {
            this.dialogVisible = true;
        },
        dialogVisibleConfirm() {
            const regPhone = /^1[3456789]\d{9}$/;
            if (this.user.c_name.trim() == "") {
                this.$notify.error("请输入姓名");
                return;
            }
            if (!regPhone.test(this.user.c_mobile)) {
                this.$notify.error("手机号码格式不正确");
                return;
            }
            //重置密码
            userApi
                .resetPassword({
                    c_name: this.user.c_name,
                    c_mobile: this.user.c_mobile,
                    c_password: md5("123456"),
                })
                .then((res) => {
                    if (res.data.code === 200) {
                        this.$message({
                            message: '你密码成功重置为123456',
                            type: 'success'
                        })
                        // this.$notify.success(res.data.msg);
                        this.dialogVisible = false;
                    } else {
                        this.$notify.error(res.data.msg);
                        this.dialogVisible = true;
                    }
                });
        },
        handleClose() {
            this.dialogVisible = false;
        },
        getOtherQuery(query) {
            return Object.keys(query).reduce((acc, cur) => {
                if (cur !== "redirect") {
                    acc[cur] = query[cur];
                }
                return acc;
            }, {});
        },
        gotoSign() {
            this.$router.push({ path: "/sign" });
        },
        // afterQRScan() {
        //   if (e.key === 'x-admin-oauth-code') {
        //     const code = getQueryObject(e.newValue)
        //     const codeMap = {
        //       wechat: 'code',
        //       tencent: 'code'
        //     }
        //     const type = codeMap[this.auth_type]
        //     const codeName = code[type]
        //     if (codeName) {
        //       this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
        //         this.$router.push({ path: this.redirect || '/' })
        //       })
        //     } else {
        //       alert('第三方登录失败')
        //     }
        //   }
        // }
    },
};
</script>

<style scoped>
.ls {
    position: absolute;
    top: 40%;
    left: 25%;
    transform: translate(-50%, -50%);
    width: 350px;
    background: rgba(0, 0, 0, 0.4);
    padding: 40px 30px;
    border-radius: 10px;

    box-shadow: 10px 10px 10px rgba(255, 255, 255, 0.3);
    /*
  backdrop-filter: blur(5px);
  border-radius: 10px;
  border: 0px solid rgba(82, 93, 128, 1);
  padding: 30px; */
}

.ls .title {
    text-align: center;
    color: #fff;
}

.login-container {
    width: 100vw;
    height: 100vh;
    /* background-size: 100% 100%; */
    /* background-repeat: no-repeat;
    background-position: bottom;
    background-origin: border-box;
    -webkit-background-size: cover;
    -o-background-size: cover; */
    position: relative;
    /* bottom: 0px; */
    top: 0;
    left: 0;
    /* overflow: hidden; */
    background: url("../../static/bgc.png");
    background-size: 100% 100%;
    overflow: hidden;
}

.show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    cursor: pointer;
    user-select: none;
}

.thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
}

@media only screen and (max-width: 470px) {
    .thirdparty-button {
        display: none;
    }
}

.ls /deep/ .el-input__inner {
    color: #fff;
    background: transparent;
}

/* .ls /deep/ .el-input__inner {
    color: #fff;
    background: transparent;
} */


/* input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    -webkit-transition-delay: 111111s;
    -webkit-transition: color 11111s ease-out, background-color 111111s ease-out;
} */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
    background: transparent;
    -webkit-box-shadow: 0 0 0px 1000px rgba(0, 0, 0, 0.4) inset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue